/**
 * Caile campurilor respinse de Zod (ex. `adresaLivrare.codPostal`), unice, in ordinea aparitiei —
 * pentru telemetria `school_request_failed`. Doar NUMELE campurilor, niciodata valorile.
 * O problema fara cale (refine pe tot obiectul) apare ca `(formular)`.
 */
export function campuriDinProblemeZod(probleme: ReadonlyArray<{ path: ReadonlyArray<PropertyKey> }>): string[] {
    return [...new Set(probleme.map((p) => p.path.map(String).join('.') || '(formular)'))];
}
